import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';
import { isAfter } from 'date-fns';

import { BlueprintRevealStatus } from '#src/__generated__/globalTypes.ts';
import { withFragments } from '#src/lib/gql/index.ts';

import { earlyAccessOverlay2024 } from './EarlyAccess/2024/index.tsx';
import { earlyAccessOverlay2025 } from './EarlyAccess/2025/index.tsx';
import type { earlyAccessOverlay_AnyCardInterface } from './__generated__/earlyAccess.graphql.ts';

export const earlyAccessOverlay = withFragments(
  (card_: earlyAccessOverlay_AnyCardInterface) => {
    const card = card_;
    const { blueprint } = card;
    if (
      !blueprint ||
      blueprint.revealStatus === BlueprintRevealStatus.REVEALED
    ) {
      return undefined;
    }

    if (
      blueprint.launchDate &&
      isAfter(blueprint.launchDate, new Date('2025-06-01'))
    ) {
      return earlyAccessOverlay2025(card);
    }

    return earlyAccessOverlay2024(card);
  },
  {
    AnyCardInterface: gql`
      fragment earlyAccessOverlay_AnyCardInterface on AnyCardInterface {
        slug
        cardEditionName
        seasonYear
        blueprint {
          id
          launchDate
        }
        ...earlyAccessOverlay2024_AnyCardInterface
        ...earlyAccessOverlay2025_AnyCardInterface
      }
      ${earlyAccessOverlay2024.fragments.AnyCardInterface}
      ${earlyAccessOverlay2025.fragments.AnyCardInterface}
    ` as TypedDocumentNode<earlyAccessOverlay_AnyCardInterface>,
  }
);
